import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Col, Form, FormFeedback, FormGroup, Input, InputGroup, Label, Row } from 'reactstrap'
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom';
import useApi from 'common/ApiMiddlewere';
import { dateFormat, dateTimeFormatIOS, formatDateToISO } from 'pages/Common';
import { routes } from 'routes/path';
import RentMakingFormTable from './RentMakingFormTable';
import { WeddingData } from '_mock/Static_data';
import UnbillRentOccasionTable from './UnbillRentOccasionTable';

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

let weddigData = 1
let occasionListData = []
const RentCreate = ({ unbillId }) => {
    const flatpickrRef = useRef(null);
    const navigate = useNavigate()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const getCurrentTime = () => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    };
    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [rentId, setRentId] = useState(unbillId)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [occasionDate, setOccasionDate] = useState(dateFormat(new Date(), "dd-MM-yyyy"))
    const [userFilter, setUserFilter] = useState({
        label: 'Select user',
        value: 0,
    })
    const [userControls, setUserControls] = useState([])
    const [categoryId, setCategoryId] = useState(0)
    const [categories, setCategories] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [isCategoryError, setIsCategoryError] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [isUserError, setIsUserError] = useState(false)
    const [occasionTableData, setOccasionTableData] = useState([])
    const [timeIn, setTimeIn] = useState(getCurrentTime());
    const [timeOut, setTimeOut] = useState(getCurrentTime());
    const [occasionFilterData, setOccasionFilterData] = useState([])
    const [editUnbillRentData, setEditUnbillRentData] = useState()
    const [wedding, setWedding] = useState(1)

    useEffect(() => {
        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                options.unshift({
                    label: "Select user",
                    value: 0,
                }
                );
                setUserControls(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

        getApi("Common/category/lookup").then(({ data, status }) => {
            if (status === 200) {
                setCategories(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })


    }, [])

    useEffect(() => {
        if (unbillId > 0) {
            setScreenLoad(true)
            setIsEdit(true)
            getApi(`Unbill/rent/details?id=${unbillId}`).then(({ data, status }) => {
                if (status === 200) {
                    setEditUnbillRentData(data?.UnbillRentDetail)
                    setOccasionTableData(data?.UnBillRentOccasionList)
                    setOccasionFilterData(data?.UnBillRentOccasionList)
                    occasionListData = data?.UnBillRentOccasionList
                    setUserFilter(
                        {
                            label: data ? data?.UnbillRentDetail?.AttendByName : 'Select user',
                            value: data ? data?.UnbillRentDetail?.AttendBy : 0,
                        }
                    )
                    setOccasionDate(dateFormat(data ? new Date(data?.UnbillRentDetail?.OccasionDate) : new Date(), "dd-MM-yyyy"))
                    setWedding(data?.UnbillRentDetail?.Wedding)
                    weddigData = (data?.UnbillRentDetail?.Wedding)
                    setCategoryId(data?.UnbillRentDetail?.CategoryId)
                    setTimeIn(data?.UnbillRentDetail?.TimeIn)
                    setTimeOut(data?.UnbillRentDetail?.TimeOut)
                    setScreenLoad(false)
                } else {
                    setScreenLoad(false)
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        } else {
            setWedding(1)

            getApi("Common/occasion/list").then(({ data, status }) => {
                if (status === 200) {
                    let occasionData = data.map((item) => ({
                        Id: 0,
                        Relation: 0,
                        OccasionId: item.Id,
                        OccasionName: item.Name,
                        ItemCode: ""
                    }));
                    setOccasionTableData(occasionData)
                    occasionListData = occasionData
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
            getApi(`Unbill/get-unbillrent-cardno`).then(({ data, status }) => {
                if (status === 200) {
                    validation.setFieldValue("CardNo", data)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
    }, [unbillId])

    useEffect(() => {
        setWedding(weddigData)
    }, [weddigData])


    const handleCancel = () => {
        weddigData = 1
        navigate(routes.rentmakinglist, {
            state: {
                tab: "1",
            },
        })
    }

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            CardNo: isEdit ? editUnbillRentData?.CardNo : "",
            Name: isEdit ? editUnbillRentData?.Name : "",
            ContactNo: isEdit ? editUnbillRentData?.ContactNo : "",
            City: isEdit ? editUnbillRentData?.City : "",
            Remark: isEdit ? editUnbillRentData?.Remark : "",
            Referral: isEdit ? editUnbillRentData?.Referral : "",
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("The name is required"),
            ContactNo: Yup.string().required("The contact no is required"),
            City: Yup.string().required("The city is required"),
        }),
        onSubmit: values => {
            if (parseInt(categoryId) == 0) {
                setIsCategoryError(true)
                setErrorMessage("The category is required")
                return true
            } else if (parseInt(userFilter?.value) == 0) {
                setIsUserError(true)
                setErrorMessage("The attend by is required")
                return true
            }
            if (occasionFilterData.length == 0) {
                toast.error("Please select at least one occasion", {
                    style: {
                        fontSize: "15px",
                    },
                })
                return true
            }

            if (values) {
                setformSumitLoading(true)

                isEdit
                    ?
                    putApi("unbill/rent/update", {
                        Id: rentId,
                        CardNo: parseInt(values.CardNo),
                        Name: values.Name,
                        ContactNo: values.ContactNo,
                        OccasionDate: formatDateToISO(occasionDate),
                        CategoryId: parseInt(categoryId),
                        City: values.City,
                        Wedding: parseInt(wedding || 0),
                        AttendBy: parseInt(userFilter.value),
                        TimeIn: timeIn,
                        TimeOut: timeOut,
                        Referral: values.Referral || '',
                        Remark: values.Remark,
                        UnbillRentOccasion: occasionFilterData,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            handleCancel()
                            setIsEdit(false)
                            toast.success("successfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            validation.handleReset()
                        }
                    })
                    :
                    postApi("unbill/rent/create", {
                        CardNo: parseInt(values.CardNo),
                        Name: values.Name,
                        ContactNo: values.ContactNo,
                        OccasionDate: formatDateToISO(occasionDate),
                        CategoryId: parseInt(categoryId),
                        City: values.City,
                        Wedding: parseInt(wedding),
                        AttendBy: parseInt(userFilter.value),
                        TimeIn: timeIn,
                        TimeOut: timeOut,
                        Referral: values.Referral,
                        Remark: values.Remark,
                        UnbillRentOccasion: occasionFilterData,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            handleCancel()
                            toast.success("successfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    const handleFieldChange = (rowIndex, field, value) => {
        const updatedData = [...occasionListData];
        updatedData[rowIndex][field] = value;
        setOccasionTableData(updatedData);
        occasionListData = updatedData
        const filteredData = updatedData.filter(row => row?.Relation > 0);
        setOccasionFilterData(filteredData);
    };

    const columns = useMemo(
        () => [
            {
                Header: "Bride",
                accessor: "Relation",
                width: "5%",
                Cell: ({ row }) => {
                    const { Relation } = row.original;
                    return (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <input
                                name={`bride-${row.index}`}
                                type="radio"
                                className="form-check-input"
                                defaultChecked={Relation === 1}
                                onChange={() => handleFieldChange(row.index, "Relation", 1)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: "Bride's Friends",
                accessor: "BridesFriends",
                width: "7%",
                Cell: ({ row }) => {
                    const { Relation } = row.original;
                    return (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <input
                                name={`bride-${row.index}`}
                                type="radio"
                                className="form-check-input"
                                defaultChecked={Relation === 2}
                                onChange={() => handleFieldChange(row.index, "Relation", 2)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: "Bride's Family",
                accessor: "BridesFamily",
                width: "7%",
                Cell: ({ row }) => {
                    const { Relation } = row.original;
                    return (
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <input
                                name={`bride-${row.index}`}
                                type="radio"
                                className="form-check-input"
                                defaultChecked={Relation === 3}
                                onChange={() => handleFieldChange(row.index, "Relation", 3)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: "Occasion",
                accessor: "OccasionName",
            },
            {
                Header: "Item Code",
                accessor: "ItemCode",
                width: "20%",
                Cell: ({ row }) => (
                    <Input
                        style={{ height: "27px" }}
                        placeholder="Item Code"
                        value={row.original.ItemCode}
                        onChange={(e) =>
                            handleFieldChange(row.index, "ItemCode", e.target.value)
                        }
                    />
                ),
            },
        ],
        [categoryId]
    );

    const checkboxHandle = (value) => {
        setWedding(Number(value))
    }

    return (
        <>
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Form
                    onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                    }}
                    onReset={e => {
                        e.preventDefault
                        validation.handleReset()
                        return false
                    }}
                >

                    <Row>
                        <Col md={1} className="">
                            <div className="mb-2">
                                <Label
                                    htmlFor="validationCustom03"
                                    className="required"
                                >
                                    Card No.
                                </Label>
                                <InputGroup style={{ paddingRight: "0px" }}>
                                    <Input
                                        disabled
                                        name="CardNo"
                                        placeholder=" Card No."
                                        type="text"
                                        onKeyPress={handleKeyPress}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.CardNo || ""}
                                    />
                                </InputGroup>
                            </div>
                        </Col>
                        <Col md={4} className="">
                            <div className="mb-2">
                                <Label
                                    htmlFor="validationCustom03"
                                    className="required"
                                >
                                    Name
                                </Label>
                                <InputGroup style={{ paddingRight: "0px" }}>
                                    <Input
                                        name="Name"
                                        placeholder=" Name"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name || ""}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </InputGroup>
                            </div>
                        </Col>
                        <Col md="2" className="">
                            <div className="mb-2">
                                <Label
                                    htmlFor="validationCustom03"
                                    className="required"
                                >
                                    Contact No
                                </Label>
                                <Input
                                    name="ContactNo"
                                    placeholder="Contact No."
                                    type="text"
                                    maxLength="10"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.ContactNo || ""}
                                    onKeyPress={handleKeyPress}
                                    invalid={
                                        validation.touched.ContactNo &&
                                            validation.errors.ContactNo
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.ContactNo &&
                                    validation.errors.ContactNo ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.ContactNo}
                                    </FormFeedback>
                                ) : null}
                            </div>
                        </Col>
                        <Col md={2} className="">
                            <div className="mb-2">
                                <Label
                                    htmlFor="productDetailsValidationCustom01"
                                    className="required"
                                >
                                    Occasion Date
                                </Label>
                                <div className="d-flex date-after" >
                                    <Flatpickr
                                        ref={flatpickrRef}
                                        className="form-control d-block flatpicker-date"
                                        placeholder="dd-MM-yyyy"
                                        value={occasionDate}
                                        onChange={(e) => setOccasionDate(e)}
                                        options={{
                                            dateFormat: "d-m-Y",
                                            disableMobile: true
                                        }}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md="1" className="">
                            <div className="mb-2">
                                <Label
                                    htmlFor="validationCustom03"
                                    className="required"
                                >
                                    City
                                </Label>
                                <Input
                                    name="City"
                                    placeholder="City"
                                    type="text"
                                    className="form-control-sm"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.City || ""}
                                    invalid={
                                        validation.touched.City &&
                                            validation.errors.City
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.City &&
                                    validation.errors.City ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.City}
                                    </FormFeedback>
                                ) : null}
                            </div>
                        </Col>
                        <Col md="2" className="table-header">
                            <Label
                                htmlFor="validationCustom03"
                                className="required"
                            >
                                Category
                            </Label>
                            <Input
                                disabled={isEdit}
                                type="select"
                                id="validationCustom01"
                                bsSize='sm'
                                className="form-control-sm"
                                name="category"
                                onChange={e => {
                                    setCategoryId(e.target.value)
                                    setIsCategoryError(false)
                                }}
                                value={categoryId}
                            >
                                <option value={0}>Select Category</option>
                                {categories.map((item, index) => {
                                    return (
                                        <option key={index} value={item.Key}>{item.Value}</option>
                                    )
                                })}
                            </Input>
                            {isCategoryError ? (
                                <div className="name-required">
                                    {errorMessage}
                                </div>
                            ) : null}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className='mt-3'>
                            <Label
                                htmlFor="validationCustom03"
                                className=""
                            >
                                Remark
                            </Label>
                            <Input
                                name="Remark"
                                placeholder="Remark"
                                type="textarea"
                                rows={2}
                                className="form-control-sm"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.Remark || ""}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-1 mt-3">
                        <span>Wedding</span>
                        <div style={{ display: "flex", gap: "20px" }}>
                            {WeddingData.map(([label, value]) => (
                                <div key={value} style={{ display: "flex", alignItems: "end", marginLeft: "8px" }}>
                                    <FormGroup check>
                                        <Input
                                            type="radio"
                                            name="wedding"
                                            id={label}
                                            value={value}
                                            checked={wedding === value}
                                            // onChange={checkboxHandle}
                                            onClick={() => checkboxHandle(value)}
                                        />
                                    </FormGroup>
                                    <Label for={label} check style={{ cursor: "pointer", marginTop: "5px" }}>
                                        {label}
                                    </Label>
                                </div>
                            ))}
                        </div>
                    </Row>
                    <Row className='mt-3'>
                        <UnbillRentOccasionTable
                            columns={columns}
                            data={occasionTableData}
                            customPageSize={10}
                            className="custom-header-css"
                            isLoading={isLoading}
                        />
                    </Row>
                    <Row className="mt-3">
                        <Col md={3}>
                            <FormGroup className="mb-2">
                                <Label
                                    htmlFor="example-time-input"
                                    className="col-form-Label required"
                                >
                                    Attend By
                                </Label>
                                <Select
                                    unstyled
                                    styles={colourStyles}
                                    value={userFilter}
                                    onChange={(e) => {
                                        setUserFilter(e)
                                        setIsUserError(false)
                                    }}
                                    options={userControls}
                                    className="select2-selection"
                                />
                                {isUserError ? (
                                    <div className="name-required">
                                        {errorMessage}
                                    </div>
                                ) : null}
                            </FormGroup>
                        </Col>
                        <Col md={2}>
                            <Label
                                htmlFor="example-time-input"
                                className="col-form-Label"
                            >
                                Time In
                            </Label>
                            <div className="">
                                <Input
                                    id="time-in"
                                    className="form-control-sm"
                                    type="time"
                                    value={timeIn}
                                    onChange={(e) => setTimeIn(e.target.value)}
                                />
                            </div></Col>
                        <Col md={2}>
                            <Label
                                htmlFor="example-time-input"
                                className=" col-form-Label"
                            >
                                Time Out
                            </Label>
                            <div className="">
                                <Input
                                    id="time-out"
                                    className="form-control-sm"
                                    type="time"
                                    value={timeOut}
                                    onChange={(e) => setTimeOut(e.target.value)}
                                />
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className="" style={{ display: "flex", alignItems: "end", marginLeft: "8px", justifyContent: "flex-start" }}>

                                <InputGroup style={{ paddingRight: "0px" }}>
                                    <Label
                                        htmlFor="validationCustom03"
                                        className=""
                                    >
                                        Referral
                                    </Label>
                                    <div style={{ display: "flex", width: "100%" }}>

                                        {/* <div
                                        className="input-group-append"
                                    >
                                        <div className="form-control " style={{ padding: "6px", borderRight: "none", backgroundColor: "#EFF2F7", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                            <input
                                                id="checkbox"
                                                type="checkbox"
                                                style={{ width: "15px", height: "15px", cursor: "pointer" }}
                                            // defaultChecked={dateDisble}
                                            // onChange={e => setdateDisble(e.target.value)}
                                            // ref={checkbox}
                                            />
                                        </div>
                                    </div> */}
                                        <div className="mb-2">

                                            <Input
                                                name="Referral"
                                                placeholder="Referral"
                                                type="text"
                                                className="form-control-sm"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.Referral || ""}
                                            />
                                        </div>
                                    </div>
                                </InputGroup>
                            </div>
                        </Col>
                    </Row>
                    <div className="text-end mt-3">
                        <Button
                            task-title="secondary"
                            className="btn btn-primary me-2 btn-sm "
                            type="button"
                            color="secondary"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        {formSumitLoading ? (
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                            >
                                <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                Loading
                            </button>
                        ) : (
                            <Button
                                color="primary"
                                task-title="primary"
                                className="btn btn-primary btn-sm "
                                type="submit"
                            >
                                Submit
                            </Button>
                        )}
                    </div>
                </Form>
            </div>
        </>
    )
}

export default RentCreate